<div class="cart-view">

  <div class="cart-info">
    <h1>Товары в корзине</h1>

    <h2 *ngIf="getProductsInStock().length > 0">Из наличия</h2>
    <div *ngFor="let pr of getProductsInStock()" class="products">
      <cart-item [product]="pr.product" [count]="pr.count"></cart-item>
    </div>

    <h2 *ngIf="getProductsToOrder().length > 0">Под заказ</h2>
    <div *ngIf="getProductsToOrder().length > 0" class="delivery-warning ">При оплате товаров под заказ берется предоплата 50%.</div>
    <div *ngIf="getProductsToOrder().length > 0" class="delivery-warning">{{deliveryWarningText}}</div>

    <div *ngFor="let pr of getProductsToOrder()" class="products">
      <cart-item [product]="pr.product" [count]="pr.count"></cart-item>
    </div>

    <h2 *ngIf="certificatesToOrder.length > 0">Подарочные сертификаты</h2>
    <div *ngFor="let pr of certificatesToOrder" class="products">
      <certificate-cart-item [certificate]="pr.certificate" [count]="pr.count"></certificate-cart-item>
    </div>


  </div>
  <div class="cart-buttons" *ngIf="products.length > 0 || certificatesToOrder.length > 0">
    <div class="gift-card" *ngIf="products.length > 0">
      <h3>Введите промокод</h3>
      <div class="promo-input">
        <input class="base-input promocode" [(ngModel)]="giftCard"/>
        <button mat-button class=" main-button" (click)="addGiftCard()">Применить</button>
      </div>

      <div class="error-card" *ngIf="errorCard && errorCertificate && !cardUsed">Номер не найден</div>
      <div class="error-card" *ngIf="cardUsed">Данный сертификат уже использован</div>

      <div *ngIf="promocode">
        <div>Промокод {{promocode.number}} применен</div>
        <div class="delete" (click)="deletePromo()">
          <img src="../../../assets/icons/cross.svg" class="delete-icon">
          Удалить промокод
        </div>
      </div>
      <div *ngIf="cardGifts">
        <div *ngFor="let card of cardGifts">
          <div>Подарочный сертификат {{card.number}} на {{card.amount| number : '1.2-2' | currency: "EUR"}} применен</div>
          <div class="delete" (click)="deleteGiftCard(card)">
            <img src="../../../assets/icons/cross.svg" class="delete-icon">
            Удалить сертификат
          </div>
        </div>
      </div>
    </div>

    <div class="cost-block" *ngIf="getProductsInStock().length > 0 && ordersPriceValues?.usualOrder">
      <h3>Стоимость товаров в наличии</h3>

      <div class="cost-row">
        <div>Товары ({{ getProductsCount(getProductsInStock()) }}шт):</div>
        <div class="separate"></div>
        <div class="count">{{ordersPriceValues.usualOrder.fullPrice | number : '1.2-2' | currency: "EUR"}}</div>
      </div>
      <div *ngIf="ordersPriceValues.usualOrder.fullPrice > ordersPriceValues.usualOrder.discountPrice" class="cost-row">
        <div>Скидка по акции:</div>
        <div class="separate"></div>AAAAA
        <div class="count discount-count">-{{productService.roundPrice(ordersPriceValues.usualOrder.fullPrice - ordersPriceValues.usualOrder.discountPrice) | number : '1.2-2' | currency: "EUR" }}</div>
      </div>
      <div *ngIf="ordersPriceValues.usualOrder.discountPrice > ordersPriceValues.usualOrder.promoPrice" class="cost-row">
        <div>Скидка по промокоду:</div>
        <div class="separate"></div>
        <div class="count discount-count">-{{productService.roundPrice(ordersPriceValues.usualOrder.discountPrice - ordersPriceValues.usualOrder.promoPrice) | number : '1.2-2' | currency: "EUR"}}</div>
      </div>
      <div *ngIf="ordersPriceValues.usualOrder.paidByCertificate > 0" class="cost-row">
        <div>Подарочные сертификаты</div>
        <div class="separate"></div>
        <div class="count discount-count">-{{ordersPriceValues.usualOrder.paidByCertificate | number : '1.2-2'| currency: "EUR" }}</div>
      </div>

      <div class="cost-row total ">
        <div>
          Итого:
        </div>
        <div class="count">
          <span *ngIf="ordersPriceValues.usualOrder.promoPrice < ordersPriceValues.usualOrder.fullPrice" class="full-cost">
            {{ordersPriceValues.usualOrder.fullPrice | number : '1.2-2' | currency: "EUR" }}
          </span>
          {{ordersPriceValues.usualOrder.toPay | number : '1.2-2' | currency: "EUR"}} </div>
      </div>

    </div>
    <div class="cost-block" *ngIf="getProductsToOrder().length > 0 && ordersPriceValues?.preorder">
      <h3>Стоимость товаров под заказ</h3>

      <div class="cost-row">
        <div>Товары ({{ getProductsCount(getProductsToOrder()) }}шт):</div>
        <div class="separate"></div>
        <div class="count">{{ordersPriceValues.preorder.fullPrice| number : '1.2-2' | currency: "EUR"}}</div>
      </div>
      <div *ngIf="ordersPriceValues.preorder.fullPrice > ordersPriceValues.preorder.discountPrice" class="cost-row">
        <div>Скидка по акции:</div> getProductsCount
        <div class="separate"></div>
        <div class="count discount-count">-{{productService.roundPrice(ordersPriceValues.preorder.fullPrice - ordersPriceValues.preorder.discountPrice)| number : '1.2-2' | currency: "EUR"}}</div>
      </div>
      <div *ngIf="ordersPriceValues.preorder.discountPrice > ordersPriceValues.preorder.promoPrice" class="cost-row">
        <div>Скидка по промокоду:</div>
        <div class="separate"></div>
        <div class="count discount-count">-{{productService.roundPrice(ordersPriceValues.preorder.discountPrice - ordersPriceValues.preorder.promoPrice) | number : '1.2-2' | currency: "EUR"}}</div>
      </div>

      <div class="cost-row">
        <div>Предоплата:</div>
        <div class="separate"></div>
        <div class="count">{{ordersPriceValues.preorder.fullPrice / 2 | number : '1.2-2' | currency: "EUR"}}</div>
      </div>
      <div *ngIf="ordersPriceValues.preorder.paidByCertificate > 0" class="cost-row">
        <div>Подарочные сертификаты</div>
        <div class="separate"></div>
        <div class="count discount-count">-{{ordersPriceValues.preorder.paidByCertificate | number : '1.2-2'| currency: "EUR" }}</div>
      </div>


      <div class="cost-row total ">
        <div>
          Итого:
        </div>
        <div class="count">
<!--          <span *ngIf="ordersPriceValues.preorder.promoPrice < ordersPriceValues.preorder.fullPrice" class="full-cost">-->
<!--            {{ordersPriceValues.preorder.fullPrice| number : '1.2-2' | currency: "EUR"}}-->
<!--          </span>-->
<!--          {{ordersPriceValues.preorder.toPay | number : '1.2-2' | currency: "EUR"}}</div>-->
<!--        <span *ngIf="ordersPriceValues.usualOrder.promoPrice < ordersPriceValues.usualOrder.fullPrice" class="full-cost">-->
<!--            {{ordersPriceValues.preorder.fullPrice | number : '1.2-2' | currency: "EUR" }}-->
<!--          </span>-->
        {{ getPreorderToPayAmount() | number : '1.2-2' | currency: "EUR"}} </div>
      </div>

    </div>
    <div class="cost-block" *ngIf="certificatesToOrder.length > 0 && ordersPriceValues?.certificatesOrder">
      <h3>Стоимость сертификатов</h3>

      <div class="cost-row">
        <div>Товары ({{certificatesToOrder.length }}шт):</div>
        <div class="separate"></div>
        <div class="count">{{ordersPriceValues.certificatesOrder.fullPrice| number : '1.2-2' | currency: "EUR"}}</div>
      </div>

      <div class="cost-row total ">
        <div>
          Итого:
        </div>
        <div class="count">

          {{ordersPriceValues.certificatesOrder.toPay| number : '1.2-2' | currency: "EUR"}}</div>
      </div>


    </div>
    <div class="buttons">
      <button mat-button class="order-button main-button" (click)="createOrder()">Оформить заказ</button>
      <button mat-button class="back-button main-button" (click)="continueShopping()">Продолжить покупки</button>
    </div>

  </div>


</div>
